import { render } from "./App.vue?vue&type=template&id=2932df70"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2932df70&lang=css"

import exportComponent from "E:\\devops.aliyun\\fengtaitiyu\\smart-sports-bigdata-screen\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__